import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot,
  RouterStateSnapshot, Router } from '@angular/router';
import { HttpService } from '../service/http.service';
import { Observable } from 'rxjs';

@Injectable()
export class AuthGaurdService implements CanActivate {

  constructor(private http: HttpService,
              private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean{
      if(this.http.isLocalAuthenticated() === true){
        return true;
      }else{
        this.router.navigate(['/']);
        return false;

      }
  }

}
